/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
//  *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

import Main from '@/components/main'
// import Home from '@/pages/single-page/home'
import Statistics2 from '@/pages/statistics/index.v2'
import Shops from '@/pages/shops'
import Orders from '@/pages/orders'
import OrderShow from '@/pages/orders/show'
// import WechatOrders from '@/pages/wechat_orders'
// import WechatOrderShow from '@/pages/wechat_orders/show'
import P401 from '@/pages/error-page/401.vue'
import P500 from '@/pages/error-page/500.vue'
import P404 from '@/pages/error-page/404.vue'

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/pages/account/login')
  },
  // {
  //   path: '/',
  //   name: '_home',
  //   redirect: '/home',
  //   component: Main,
  //   meta: {
  //     notCache: true,
  //     icon: 'ios-pie'
  //   },
  //   children: [
  //     {
  //       path: '/home',
  //       name: 'home',
  //       meta: {
  //         title: '数据概览',
  //         notCache: true,
  //         icon: 'ios-pie'
  //       },
  //       component: Home
  //     }
  //   ]
  // },
  {
    path: '/',
    name: '_statistics',
    redirect: '/statistics2',
    component: Main,
    meta: {
      notCache: true,
      icon: 'ios-pie',
      title: '数据统计'
    },
    children: [
      {
        path: '/statistics2',
        name: 'statistics2',
        meta: {
          title: '数据大盘',
          notCache: true,
          icon: 'ios-pie'
        },
        component: Statistics2
      }
    ]
  },
  {
    path: '/',
    name: 'shops',
    component: Main,
    meta: {
      hideInBread: true,
      notCache: true,
      title: '所有店铺',
      icon: 'ios-appstore',
      access: ['editor', 'admin']
    },
    children: [
      {
        path: 'shops/shops',
        name: 'shops-shops',
        meta: {
          icon: 'ios-appstore',
          title: '所有店铺'
        },
        component: Shops
      }
    ]
  },
  {
    path: '/',
    name: 'chain_stores',
    meta: {
      icon: 'logo-buffer',
      title: '连锁店',
      access: ['editor', 'admin']
    },
    component: Main,
    children: [
      {
        path: '/chain_stores',
        name: 'chain_stores-chain_stores',
        meta: {
          icon: 'md-attach',
          title: '连锁店'
        },
        component: () => import('@/pages/chain_stores')
      },
      {
        path: 'chain_stores/:id',
        name: 'chain_stores-items',
        meta: {
          icon: 'ios-attach',
          hideInMenu: true,
          title: '连锁店详情'
        },
        component: () => import('@/pages/chain_stores/show')
      }
    ]
  },
  // {
  //   path: '/products',
  //   name: 'products',
  //   meta: {
  //     icon: 'logo-buffer',
  //     title: '内容管理',
  //     access: ['editor', 'admin']
  //   },
  //   component: Main,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'products-products',
  //       meta: {
  //         icon: 'md-attach',
  //         title: '商品管理'
  //       },
  //       component: () => import('@/pages/products')
  //     }
  //   ]
  // },
  {
    path: '/banners',
    name: 'banners',
    meta: {
      icon: 'ios-book',
      title: '轮播图',
      access: ['editor', 'admin'],
      hideInBread: true
    },
    component: Main,
    children: [
      {
        path: 'banners',
        name: 'banners-banner',
        meta: {
          icon: 'md-attach',
          title: '轮播图'
        },
        component: () => import('@/pages/banners')
      }
    ]
  },
  {
    path: '/',
    name: 'orders',
    meta: {
      icon: 'logo-buffer',
      title: '报表管理',
      access: ['editor', 'admin']
    },
    component: Main,
    children: [
      {
        path: 'orders',
        name: 'orders-orders',
        meta: {
          icon: 'ios-document',
          title: '订单管理'
        },
        component: Orders
      },
      {
        path: 'orders/:id',
        name: 'orders-items',
        meta: {
          icon: 'ios-attach',
          hideInMenu: true,
          title: '订单详情'
        },
        component: OrderShow
      }
    ]
  },
  {
    path: '/',
    name: 'charge_coupons',
    meta: {
      icon: 'logo-buffer',
      title: '充值赠送模板',
      access: ['editor', 'admin']
    },
    component: Main,
    children: [
      {
        path: 'charge_coupons',
        name: 'customers-charge_coupons',
        meta: {
          icon: 'logo-usd',
          title: '充值赠送模板',
          require_permission: 'settings:charge_templates'
        },
        component: () => import('@/pages/charge_coupons')
      }
    ]
  },
  // {
  //   path: '/',
  //   name: 'wechat-orders',
  //   meta: {
  //     icon: 'logo-buffer',
  //     title: '微信小程序',
  //     access: ['editor', 'admin']
  //   },
  //   component: Main,
  //   children: [
  //     {
  //       path: 'wechat_orders',
  //       name: 'wechat-orders-orders',
  //       meta: {
  //         icon: 'ios-document',
  //         title: '小程序订单'
  //       },
  //       component: WechatOrders
  //     },
  //     {
  //       path: 'wechat_orders/:id',
  //       name: 'wechat-orders-items',
  //       meta: {
  //         icon: 'ios-attach',
  //         hideInMenu: true,
  //         title: '小程序订单详情'
  //       },
  //       component: WechatOrderShow
  //     }
  //   ]
  // },
  {
    path: '/',
    name: 'customers',
    meta: {
      icon: 'ios-people',
      access: ['editor', 'admin'],
      title: '会员管理'
    },
    component: Main,
    children: [
      {
        path: 'customers',
        name: 'customers-customers',
        meta: {
          icon: 'md-trending-up',
          title: '会员管理'
        },
        component: () => import('@/pages/customers')
      },
      {
        path: 'customers/:id/bills',
        name: 'customers-bills',
        meta: {
          icon: 'md-trending-up',
          hideInMenu: true,
          title: '充值记录'
        },
        component: () => import('@/pages/customers/bills')
      },
      {
        path: 'customers/:id/orders',
        name: 'customers-orders',
        meta: {
          icon: '_qq',
          hideInMenu: true,
          title: '他的订单'
        },
        component: () => import('@/pages/customers/orders')
      }
    ]
  },
  {
    path: '/',
    name: 'setting',
    meta: {
      icon: 'ios-book',
      title: '设置',
      access: ['editor', 'admin'],
      hideInBread: true
    },
    component: Main,
    children: [
      {
        path: 'setting/chain_stores',
        name: 'setting-chain_stores',
        meta: {
          icon: 'ios-radio',
          title: '支付设置',
          test_permission (state) {
            return state.chainStoreManner === 'chain'
          }
        },
        component: () => import('@/pages/chain_stores')
      },
      {
        path: 'settings/lcsw_accounts',
        name: 'settings-lcsw_accounts',
        meta: {
          icon: 'md-card',
          title: '商户资质'
        },
        component: () => import('@/pages/lcsw_accounts')
      }
    ]
  },
  {
    path: '/',
    name: 'settings',
    meta: {
      hideInBread: true,
      title: '设置',
      icon: 'ios-play',
      access: ['editor', 'admin'],
      require_permission: 'settings:index'
    },
    component: Main,
    children: [
      {
        path: 'settings/system',
        name: 'settings-system',
        meta: {
          icon: 'md-podium',
          title: '系统设置',
          require_permission: 'settings:system'
        },
        component: () => import('@/pages/settings')
      },
      {
        path: 'wechat_mp/wechat_configs',
        name: 'wechat_mp-wechat_configs',
        meta: {
          icon: 'ios-radio',
          title: '小程序设置',
          require_permission: 'miniprogram:wechat'
        },
        component: () => import('@/pages/wechat_configs')
      },
      {
        path: '/wechat_mp/wechat_config_success',
        name: 'wechat_mp-wechat_config_success',
        meta: {
          icon: 'ios-radio',
          title: '微信设置',
          hideInBread: true,
          hideInMenu: true
        },
        component: () => import('@/pages/wechat_configs/success')
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true,
      icon: 'md-home'
    },
    component: P401
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: P500
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: P404
  }
]
